@switch (currentSettings()) {
    @case (settingEnum.MAIN) {
        <web-widget-breadcrumbs [widget]="widget" [isInSpecificSection]="isSpecific"></web-widget-breadcrumbs>
        <div class="panel-options-body overflow-wrapper">
            @if (isTariffExpired()) {
                <div class="alert alert-paid has-paid-badge">
                    <span class="badge badge-paid">&nbsp;</span>
                    {{ "widget_product_catalog_tariff_expired_text" | translate }}
                    <a target="_blank" [href]="crmPlansUrl">
                        {{ "widget_product_catalog_tariff_expired_link" | translate }}
                        <small class="sp-icon icon-outgoing">&nbsp;</small>
                    </a>
                </div>
            }
            <div class="form form-horizontal">
                @if (hasNoAvailableCategories()) {
                    <div class="alert alert-info-mutted alert-sm mb-0">
                        {{ "catalog_control_no_available_categories" | translate }}
                    </div>
                } @else {
                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "control_products" | translate }}
                        </label>
                        <div class="col-xs-12">
                            <select class="form-control mb-5" (change)="setSelectedCategory($event.target['value'])">
                                <option
                                    [value]="null"
                                    [selected]="isAllCategoriesSelected()"
                                    [disabled]="isAllCategoriesDisabled()"
                                >
                                    {{ "catalog_all_categories" | translate }}
                                </option>
                                @for (category of flattenedCategories(); track category) {
                                    <option
                                        [value]="category.id"
                                        [selected]="isCategorySelected(category)"
                                        [disabled]="isCategoryDisabled(category)"
                                        [title]="
                                            isCategoryDisabled(category)
                                                ? ('catalog_disabled_category_tooltip' | translate)
                                                : ''
                                        "
                                    >
                                        {{ category.name }}
                                    </option>
                                }
                            </select>
                            <a target="_blank" class="dotted small" [href]="crmUrl">
                                {{ "catalog_control_help_link" | translate }}
                                <img class="font-icon" src="./assets/img/websites/lpc-new-window-icon.svg" />
                            </a>
                        </div>
                    </div>
                    <div class="form-group mb-20">
                        <div class="col-xs-12">
                            <label>
                                {{ "catalog_view_label" | translate }}
                            </label>
                            <a (click)="setCurrentSettingsType(settingEnum.GENERAL)" class="dotted pull-right">
                                {{ "catalog_control_settings" | translate }}
                            </a>
                        </div>
                        <div class="col-xs-12">
                            <div class="btn-group d-flex">
                                <button
                                    class="btn btn-grey w-100"
                                    [class.active]="catalogView.value === catalogCategoriesView.left"
                                    (click)="setCatalogView(catalogCategoriesView.left)"
                                >
                                    <img src="./assets/img/websites/lpc-cart-view-1.svg" alt="cart-view-1" />
                                </button>
                                <button
                                    class="btn btn-grey w-100"
                                    [class.active]="catalogView.value === catalogCategoriesView.top"
                                    (click)="setCatalogView(catalogCategoriesView.top)"
                                >
                                    <img src="./assets/img/websites/lpc-cart-view-2.svg" alt="cart-view-2" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "catalog_count_cards_label" | translate }}
                        </label>
                        <div class="col-xs-6">
                            <sp-input-num
                                [min]="MIN_ITEMS_IN_ROW_DESKTOP"
                                [max]="maxItemsInRow"
                                [onlyIntegers]="true"
                                [value]="itemsInRowDesktop.value"
                                (valueChange)="setItemsInRowDesktop($event)"
                            ></sp-input-num>
                            <p class="text-muted small">{{ "catalog_count_cards_desktop" | translate }}</p>
                        </div>
                        <div class="col-xs-6">
                            <sp-input-num
                                [min]="MIN_ITEMS_IN_ROW_MOBILE"
                                [max]="MAX_ITEMS_IN_ROW_MOBILE"
                                [onlyIntegers]="true"
                                [value]="itemsInRowMobile.value"
                                (valueChange)="setItemsInRowMobile($event)"
                            ></sp-input-num>
                            <p class="text-muted small">{{ "catalog_count_cards_mobile" | translate }}</p>
                        </div>
                    </div>
                    <div class="form-group mb-20">
                        <label class="col-xs-9">{{ "catalog_count_per_page_label" | translate }}</label>
                        <div class="col-xs-3">
                            <sp-input-num
                                [min]="MIN_PER_PAGE"
                                [max]="MAX_PER_PAGE"
                                [onlyIntegers]="true"
                                [value]="maxPerPage.value"
                                (valueChange)="setMaxPerPage($event)"
                            ></sp-input-num>
                        </div>
                    </div>
                    <div class="mb-20">
                        <a class="dotted" (click)="setCurrentSettingsType(settingEnum.PAGINATION)">{{
                            "catalog_pagination_settings_label" | translate
                        }}</a>
                    </div>
                    <div class="mb-20">
                        <a class="dotted" (click)="setCurrentSettingsType(settingEnum.FILTER)">{{
                            "catalog_filter_settings_label" | translate
                        }}</a>
                    </div>
                    <div class="mb-20">
                        <a class="dotted" (click)="setCurrentSettingsType(settingEnum.SORTING)">{{
                            "catalog_sorting_settings_label" | translate
                        }}</a>
                    </div>
                    <div>
                        <label>{{ "catalog_basket_button_label" | translate }}</label>
                        <sp-control-handle
                            [controlHandleCheckbox]="true"
                            [controlHandleCheckboxChecked]="basketButton.controls.isShowButton.value"
                            [controlHandleMainText]="basketButton.controls.label.value"
                            (editActionEvent)="setCurrentSettingsType(settingEnum.BUTTON)"
                            (toggleCheckBoxEvent)="setIsShowButton($event)"
                        ></sp-control-handle>
                    </div>
                }
            </div>
        </div>
    }
    @case (settingEnum.BUTTON) {
        <web-button-settings
            [itemForm]="basketButton"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        ></web-button-settings>
    }
    @case (settingEnum.GENERAL) {
        <web-general-settings
            [itemForm]="generalSettings"
            [widgetId]="getWidgetId(widget)"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        ></web-general-settings>
    }
    @case (settingEnum.PAGINATION) {
        <web-pagination-settings
            [itemForm]="paginationSettings"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        ></web-pagination-settings>
    }
    @case (settingEnum.FILTER) {
        <web-filter-settings
            [itemForm]="filterSettings"
            [catalogView]="catalogView.value"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        ></web-filter-settings>
    }
    @case (settingEnum.SORTING) {
        <web-sorting-settings
            [itemForm]="sortingSettings"
            (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
        ></web-sorting-settings>
    }
}
